import { SubmitHandler, useForm } from 'react-hook-form';

import { Button, FormGroup } from '@mui/material';

import Switch from '../../components/HookFormControls/Switch';

interface FormValues {
  apple: boolean;
  orange: boolean;
  banana: boolean;
}

const FormSwitch = () => {
  const { control, handleSubmit, reset } = useForm<FormValues>({
    defaultValues: {
      apple: false,
      orange: true,
      banana: true,
    },
  });

  const onSubmit: SubmitHandler<FormValues> = (data) => {
    console.log(data, 'data >>>>>');
    reset();
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} noValidate>
      <FormGroup>
        <Switch control={control} name="apple" label="🍏" />
        <br />
        <Switch control={control} name="orange" label="🍊" />
        <br />
        <Switch control={control} name="banana" label="🍌" disabled />
      </FormGroup>
      <br />
      <br />
      <Button type="submit" variant="contained">
        Submit
      </Button>
    </form>
  );
};

export default FormSwitch;
